module.exports = __webpack_public_path__ + "img/cert.f4b1d34c.png";